import { render } from "./StudentsInterestedTopicsChart.vue?vue&type=template&id=bd686bd8&ts=true"
import script from "./StudentsInterestedTopicsChart.vue?vue&type=script&lang=ts"
export * from "./StudentsInterestedTopicsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__